import React, { useState, useEffect } from 'react';
import { Modal, Button } from 'react-bootstrap';
import { CalendarEvent } from '../types/CalendarEvent';
import AppointmentForm from './AppointmentForm';
import { useTranslation } from 'react-i18next';
import { AppointmentType } from '../types/AppointmentType';

interface Props {
  show: boolean;
  onClose: () => void;
  onCreate: (newAppointment: CalendarEvent) => void;
  defaultDate?: string;
  defaultTime?: string;
  appointmentTypes: AppointmentType[] | null;
  durationMin : number | undefined;
}

const AppointmentCreateModal: React.FC<Props> = ({ show, onClose, onCreate, defaultDate = '', defaultTime = '', appointmentTypes, durationMin }) => {
  const { t } = useTranslation();
  const [appointment, setAppointment] = useState<CalendarEvent>({
    appointmentId: '',
    name: '',
    phone: '',
    email: '',
    date: defaultDate,
    time: defaultTime,
    durationMinutes: durationMin,
    title: '',
    comments: '',
    start: new Date(),
    end: new Date(),
    appointmentType: undefined,
  });

  useEffect(() => {
    if (show) {
      setAppointment({
        appointmentId: '',
        name: '',
        phone: '',
        email: '',
        date: defaultDate,
        time: defaultTime,
        durationMinutes: durationMin,
        title: '',
        comments: '',
        start: new Date(),
        end: new Date(),
        appointmentType: undefined,
      });
    }
  }, [show, defaultDate, defaultTime]);

  const handleChange = (field: keyof CalendarEvent, value: any) => {
    setAppointment((prev) => ({ ...prev, [field]: value }));
  };

  const handleCreate = () => {
    onCreate(appointment);
  };

  return (
    <Modal show={show} onHide={onClose} size="xl" centered backdrop="static" className="text-light" contentClassName="bg-dark">
      <Modal.Header closeButton closeVariant="white">
        <Modal.Title>{t('create-appointment')}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="px-4">
        <AppointmentForm calendarEvent={appointment} onChange={handleChange} appointmentTypes={appointmentTypes} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onClose}>
          {t('cancel')}
        </Button>
        <Button variant="primary" onClick={handleCreate}>
          {t('create-appointment')}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default AppointmentCreateModal;
